const arrowLeft = document.querySelector('.product__thumbs-wrapper .icon-arrow-left')
const arrowRight = document.querySelector('.product__thumbs-wrapper .icon-arrow-right')

const getThumbElementVariable = () => {
  const thumbsSlider = document.querySelector('.product__thumbs__holder')
  const thumbElement = document.querySelector('.product__thumb')


  if (!thumbsSlider || !thumbElement){
    return
  }

  const thumbElementWidth = thumbElement.offsetWidth + 10

  const scrollLeft = () => {
    thumbsSlider.scrollBy({
      top: 0,
      left: -Math.abs(thumbElementWidth),
      behavior: "smooth",
    });
  }

  const scrollRight = () => {
    thumbsSlider.scrollBy({
      top: 0,
      left: thumbElementWidth,
      behavior: "smooth",
    });
  }

  arrowLeft.addEventListener('click', scrollLeft)
  arrowRight.addEventListener('click', scrollRight)

  clearInterval(timerId);
}

(() => {
  timerId = setInterval(getThumbElementVariable, 200)
})();


// Main image arrows: step to the previous/next thumbnail so the slideshow and thumbs stay in sync
document.addEventListener('click', (e) => {
  const arrow = e.target.closest('[data-main-arrow]')
  if (!arrow) return

  const images = arrow.closest('.product__images')
  const thumbs = images ? Array.from(images.querySelectorAll('.js-product-slide-thumb')) : []
  if (!thumbs.length) return

  const currentIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.getAttribute('aria-current') === 'true'))
  const step = arrow.dataset.mainArrow === 'prev' ? -1 : 1
  thumbs[(currentIndex + step + thumbs.length) % thumbs.length].click()
})
